export function formatDateTime(date, time, dateSeparator = '-', timeSeparator = ':') {
    const [year, month, day] = date.split(dateSeparator).map(Number);
    const [hours, minutes] = time.split(timeSeparator).map(Number);
    return new Date(year, month - 1, day, hours, minutes);
}